export default __webpack_public_path__ + "static/media/globe.a839b0bc.svg";